import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import {COLORS} from "../../theme/themeConstants"
const features = [
  { icon: '🍽️', label: 'Food Delivery management' },
  { icon: '🛒', label: 'Grocery management' },
  { icon: '💊', label: 'Pharmacy management' },
  { icon: '📊', label: 'Analytics' },
];

const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ minHeight: '98vh', display: 'flex' }}>
    {/* Left Section */}
    <Box
      sx={{
        flex: 0.7,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255, 236, 170, 0.18)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'url(https://plus.unsplash.com/premium_photo-1671403964040-3fa56d33f44b?q=80&w=1601&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D) center/cover',
          opacity: 0.65,
          zIndex: 1,
        }}
      />
      <Box sx={{ position: 'relative', zIndex: 2, textAlign: 'center', px: 4 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            alt="Foodigo Logo"
            style={{ width: 48, height: 48, marginRight: 10 }}
          />
          <Typography variant="h5" sx={{ color: COLORS.secondary.main, fontWeight: 700 }}>
            Foodigo
          </Typography>
        </Box>
        <Typography variant="h4" sx={{ color: COLORS.secondary.main, fontWeight: 700, mb: 1 }}>
          Foodigo Admin
        </Typography>
        <Typography variant="body1" sx={{ color: COLORS.secondary.main, mb: 3 }}>
          Streamline your delivery operations with our all-in-one admin
          dashboard
        </Typography>
        <Paper
          elevation={4}
          sx={{
            display: 'inline-block',
            p: 3,
            borderRadius: 3,
            background: COLORS.primary.main,
            mb: 2,
            minWidth: 260,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2,
              justifyContent: 'center',
            }}
          >
            {features.map((f, i) => (
              <Box
                key={i}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 120,
                }}
              >
                <span style={{ fontSize: 22, marginRight: 8 }}>{f.icon}</span>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: COLORS.secondary.main }}
                >
                  {f.label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Paper>
      </Box>
    </Box>
    {/* Right Section */}
    <Box
      sx={{
        flex: 1.4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
      }}
    >
      {children}
    </Box>
  </Box>
);

export default AuthLayout;
